import React from 'react'
import styled from 'styled-components'

const WarnSection = ({error_message}) => {

  return (
    <Wrapper >
        <p className='warn-message'><b>Oops!</b> .. {error_message}</p>
    </Wrapper>
  )
}

const Wrapper = styled.div`
    width: 100%;
    margin: 0;
    animation: warnLoad 1s ease-in-out;

    .warn-message{
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: var(--warn-color);
      color: var(--color-white);
      padding: 1em;
    }

    /* Animations */
    @keyframes warnLoad{
    from{
        clip-path: polygon(0 0, 100% 0, 100% 0, 0 0);
    }
    to{
        clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
        }
    }

`

export default WarnSection